import React, { useState } from 'react';
import { BACKEND_URL } from '../config';

function WeighInModal({ isOpen, onClose, onSubmit, userId, token, currentWeight, showToast }) {
  const [weight, setWeight] = useState(currentWeight || '');
  const [notes, setNotes] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!weight) return;

    setLoading(true);
    try {
      const response = await fetch(`${BACKEND_URL}/api/weight/log`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({
          user_id: userId,
          weight: parseFloat(weight),
          notes: notes || null
        })
      });

      if (response.ok) {
        const data = await response.json();
        onSubmit(parseFloat(weight));
        onClose();
      } else {
        const error = await response.json();
        showToast?.(error.detail || 'Failed to log weight', "error");
      }
    } catch (error) {
      showToast?.('Error logging weight: ' + error.message, "error");
    }
    setLoading(false);
  };

  const handleSkip = () => {
    // Store skip timestamp in localStorage to not prompt again for a day
    localStorage.setItem('weighInSkipped', new Date().toISOString());
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="modal-overlay" data-testid="weigh-in-modal" style={{ background: "rgba(0, 0, 0, 0.6)" }}>
      <div className="modal-content"
        style={{
          background: "var(--bg-modal)",
          color: "var(--text-primary)",
          borderRadius: "16px",
          padding: "32px",
          maxWidth: "400px",
          width: "100%",
          boxShadow: "0 20px 60px rgba(0, 0, 0, 0.3)",
          border: "1px solid var(--border-light)",
        }}
      >
        <div style={{ textAlign: 'center', marginBottom: '24px' }}>
          <div style={{ fontSize: '48px', marginBottom: '12px' }}>⚖️</div>
          <h2 className="heading-3" style={{ marginBottom: '8px' }}>Weekly Weigh-In</h2>
          <p className="body-medium" style={{ color: 'var(--text-secondary)' }}>
            It's been 24 hours! Let's track your progress.
          </p>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="form-group" style={{ marginBottom: '16px' }}>
            <label className="body-medium" style={{ display: 'block', marginBottom: '8px' }}>
              Current Weight (lbs)
            </label>
            <input
              type="number"
              step="0.1"
              value={weight}
              onChange={(e) => setWeight(e.target.value)}
              placeholder="Enter your weight"
              className="form-input"
              style={{ width: '100%', fontSize: '18px', padding: '12px 16px' }}
              required
              autoFocus
              data-testid="weigh-in-input"
            />
          </div>

          <div className="form-group" style={{ marginBottom: '24px' }}>
            <label className="body-medium" style={{ display: 'block', marginBottom: '8px' }}>
              Notes (optional)
            </label>
            <input
              type="text"
              value={notes}
              onChange={(e) => setNotes(e.target.value)}
              placeholder="e.g., Morning weight, after workout..."
              className="form-input"
              style={{ width: '100%' }}
              data-testid="weigh-in-notes"
            />
          </div>

          <div style={{ display: 'flex', gap: '12px' }}>
            <button
              type="button"
              onClick={handleSkip}
              className="btn-secondary"
              style={{ flex: 1 }}
              data-testid="weigh-in-skip"
            >
              Remind Me Later
            </button>
            <button
              type="submit"
              className="btn-primary"
              style={{ flex: 1 }}
              disabled={loading || !weight}
              data-testid="weigh-in-submit"
            >
              {loading ? 'Saving...' : 'Log Weight'}
            </button>
          </div>
        </form>

        <p className="body-small" style={{ 
          textAlign: 'center', 
          color: 'var(--text-muted)', 
          marginTop: '16px' 
        }}>
          Regular weigh-ins help track your progress toward your goals!
        </p>
      </div>
    </div>
  );
}

export default WeighInModal;
